'use client';
import React__default from 'react';
import PropTypes from 'prop-types';
import { SubMenuContainer, Container } from './Menu.styles.js';
import { useOutsideClick } from '../../hooks/useOutsideClick.js';
import { SURFACE_VARIANT_KEYS } from '../../constants/variants.js';
import { DEFAULT_VARIANT } from './Menu.constants.js';

var Menu = function Menu(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? [] : _ref$children,
    _ref$isNested = _ref.isNested,
    isNested = _ref$isNested === void 0 ? false : _ref$isNested,
    _ref$onOutsideClick = _ref.onOutsideClick,
    onOutsideClick = _ref$onOutsideClick === void 0 ? function () {} : _ref$onOutsideClick,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? null : _ref$position,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? DEFAULT_VARIANT : _ref$variant;
  var ref = useOutsideClick(onOutsideClick);
  var Component = isNested ? SubMenuContainer : Container;
  return React__default.createElement(Component, {
    ref: ref,
    $bottom: position === null || position === void 0 ? void 0 : position.bottom,
    $left: position === null || position === void 0 ? void 0 : position.left,
    $right: position === null || position === void 0 ? void 0 : position.right,
    $top: position === null || position === void 0 ? void 0 : position.top,
    "data-testid": testId,
    role: "menu",
    $variant: variant
  }, children);
};
Menu.propTypes = {
  children: PropTypes.node,
  isNested: PropTypes.bool,
  onOutsideClick: PropTypes.func,
  position: PropTypes.shape({
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
    top: PropTypes.number
  }),
  testId: PropTypes.string,
  variant: PropTypes.oneOf(SURFACE_VARIANT_KEYS)
};

export { Menu, Menu as default };
//# sourceMappingURL=Menu.js.map
